// Auto generated file, do not manually modify!
// com.hotpads.renterinfo.web.api.web.v1.renterprofile.enums.RenterProfileStandalonePageCreditScore

export enum RenterProfileStandalonePageCreditScore {
  RANGE_300_579 = '300_579',
  RANGE_580_619 = '580_619',
  RANGE_620_659 = '620_659',
  RANGE_660_719 = '660_719',
  RANGE_720_PLUS = '720_PLUS',
}

export const RenterProfileStandalonePageCreditScore_values = [
  RenterProfileStandalonePageCreditScore.RANGE_300_579,
  RenterProfileStandalonePageCreditScore.RANGE_580_619,
  RenterProfileStandalonePageCreditScore.RANGE_620_659,
  RenterProfileStandalonePageCreditScore.RANGE_660_719,
  RenterProfileStandalonePageCreditScore.RANGE_720_PLUS,
] as const;
